/* eslint-disable */
import toast from '../../services/toast';
import { mapGetters } from 'vuex';
var $ = window.jQuery = require('jquery');
export default {
  name: 'public-quiz-question-answer-edit',
  components: {},
  props: [],
  data() {
    return {
      QuizList: null,
      quizDetailsEdit: null,
      quizData: [{
        quizId: ''
      }],
      submitted: false,
      questionData: [{
        content: '',
      }],
      quizQuesDetails:'',
      radio_option: '',
      content1: '',
      is_correct1: Boolean,
      index1: 1,
      content2: '',
      is_correct2: Boolean,
      index2: 2,
      content3: '',
      is_correct3: Boolean,
      index3: 3,
      content4: '',
      is_correct4: Boolean,
      index4: 4,
      content: '',
      is_correct: '',
      index: '',
      checked: true,
      optionData: '',
      keyupOption1: false,
      keyupOption2: false,
      keyupOption3: false,
      keyupOption4: false,
      optionContent: '',
      optionIs_iscorrect: Boolean,
      optiontrueactv:Boolean,
      pub_catID:''
    }
  },
  computed: {
    ...mapGetters([
      'getQuizQuesDetailsByIdDataState',
      'getQuizDetailsByIdDataState'
    ]),
    getQuizQuesdetails() {
      this.quizQuesDetails = this.$store.getters.getQuizDetailsByIdDataState
      return this.quizQuesDetails
    },
    getQuizQuestionDetails() {
      this.$store.dispatch('getQuizQueDetailssByIdFun', {
        id: this.$route.params.QueAnsId
      }).then((response) => {
        this.optionData = this.$store.getters.getQuizQuesDetailsByIdDataState.data.options
        this.questionData.content = this.$store.getters.getQuizQuesDetailsByIdDataState.data.content
        this.content1 = this.$store.getters.getQuizQuesDetailsByIdDataState.data.options[0].content
        this.content2 = this.$store.getters.getQuizQuesDetailsByIdDataState.data.options[1].content
        this.content3 = this.$store.getters.getQuizQuesDetailsByIdDataState.data.options[2].content
        this.content4 = this.$store.getters.getQuizQuesDetailsByIdDataState.data.options[3].content
        this.is_correct1 = this.$store.getters.getQuizQuesDetailsByIdDataState.data.options[0].is_correct
        this.is_correct2 = this.$store.getters.getQuizQuesDetailsByIdDataState.data.options[1].is_correct
        this.is_correct3 = this.$store.getters.getQuizQuesDetailsByIdDataState.data.options[2].is_correct
        this.is_correct4 = this.$store.getters.getQuizQuesDetailsByIdDataState.data.options[3].is_correct
        if (this.is_correct1) {
          this.radio_option = 'option1'
          this
        }
        if (this.is_correct2) {
          this.radio_option = 'option2'
        }
        if (this.is_correct3) {
          this.radio_option = 'option3'
        }
        if (this.is_correct4) {
          this.radio_option = 'option4'
        }
        setTimeout(()=>{
          CKEDITOR.instances['content1'].setData(this.content1);
          CKEDITOR.instances['content2'].setData(this.content2);
          CKEDITOR.instances['content3'].setData(this.content3);
          CKEDITOR.instances['content4'].setData(this.content4);
          CKEDITOR.instances['Questioncontent'].setData(this.questionData.content);
        },500)
      })
      return
    },
  },
  mounted() {
    this.pub_catID = this.$route.params.quiz_catId,
    this.getQuizQuesdetails
    this.quizData.quizId = this.$route.params.quizId;
    this.createEditor()
    this.getQuizQuestionDetails
  },
  methods: {
    createEditor() {
      CKEDITOR.replace('Questioncontent',{
        extraPlugins: 'mathjax',
        mathJaxLib: 'https://cdnjs.cloudflare.com/ajax/libs/mathjax/2.7.4/MathJax.js?config=TeX-AMS_HTML',
        height:150,
      });
      CKEDITOR.instances['Questioncontent'].on('change', () => {
        var content1Length = CKEDITOR.instances['Questioncontent'].getData().replace(/<[^>]*>/gi, '').length;
        if(content1Length > 0){
          $('.custom_editor_for_option #Questioncontent').attr('aria-invalid', 'false')
          $('.custom_editor_for_option #Questioncontent').removeClass('is-invalid')
          this.questionData.content = CKEDITOR.instances['Questioncontent'].getData()
        }else{
          $('.custom_editor_for_option #Questioncontent').attr('aria-invalid', 'true')
          $('.custom_editor_for_option #Questioncontent').addClass('is-invalid')
          this.questionData.content = ''
        }
      })
      CKEDITOR.replace('content1',{
        extraPlugins: 'mathjax',
        mathJaxLib: 'https://cdnjs.cloudflare.com/ajax/libs/mathjax/2.7.4/MathJax.js?config=TeX-AMS_HTML',
        height:150,
      });
      CKEDITOR.instances['content1'].on('change', () => {
        var content1Length = CKEDITOR.instances['content1'].getData().replace(/<[^>]*>/gi, '').length;
        if(content1Length > 0){
          $('.custom_editor_for_option #content1').attr('aria-invalid', 'false')
          $('.custom_editor_for_option #content1').removeClass('is-invalid')
          this.content1 = CKEDITOR.instances['content1'].getData()
          this.radiok_option1()
        }else{
          $('.custom_editor_for_option #content1').attr('aria-invalid', 'true')
          $('.custom_editor_for_option #content1').addClass('is-invalid')
          this.content1 = ''
          this.keyupOption1 = false
        }
      })
      CKEDITOR.replace('content2',{
        extraPlugins: 'mathjax',
        mathJaxLib: 'https://cdnjs.cloudflare.com/ajax/libs/mathjax/2.7.4/MathJax.js?config=TeX-AMS_HTML',
        height:150,
      });
      CKEDITOR.instances['content2'].on('change', () => {
        var content2Length = CKEDITOR.instances['content2'].getData().replace(/<[^>]*>/gi, '').length;
        if(content2Length > 0){
          $('.custom_editor_for_option #content2').attr('aria-invalid', 'false')
          $('.custom_editor_for_option #content2').removeClass('is-invalid')
          this.content2 = CKEDITOR.instances['content2'].getData()
          this.radiok_option2()
        }else{
          $('.custom_editor_for_option #content2').attr('aria-invalid', 'true')
          $('.custom_editor_for_option #content2').addClass('is-invalid')
          this.content2 = ''
          this.keyupOption2 = false
        }
      })
      CKEDITOR.replace('content3',{
        extraPlugins: 'mathjax',
        mathJaxLib: 'https://cdnjs.cloudflare.com/ajax/libs/mathjax/2.7.4/MathJax.js?config=TeX-AMS_HTML',
        height:150,
      });
      CKEDITOR.instances['content3'].on('change', () => {
        var content3Length = CKEDITOR.instances['content3'].getData().replace(/<[^>]*>/gi, '').length;
        if(content3Length > 0){
          $('.custom_editor_for_option #content3').attr('aria-invalid', 'false')
          $('.custom_editor_for_option #content3').removeClass('is-invalid')
          this.content3 = CKEDITOR.instances['content3'].getData()
          this.radiok_option3()
        }else{
          $('.custom_editor_for_option #content3').attr('aria-invalid', 'true')
          $('.custom_editor_for_option #content3').addClass('is-invalid')
          this.content3 = ''
          this.keyupOption3 = false
        }
      })
      CKEDITOR.replace('content4',{
        extraPlugins: 'mathjax',
        mathJaxLib: 'https://cdnjs.cloudflare.com/ajax/libs/mathjax/2.7.4/MathJax.js?config=TeX-AMS_HTML',
        height:150,
      });
      CKEDITOR.instances['content4'].on('change', () => {
        var content4Length = CKEDITOR.instances['content4'].getData().replace(/<[^>]*>/gi, '').length;
        if(content4Length > 0){
          $('.custom_editor_for_option #content4').attr('aria-invalid', 'false')
          $('.custom_editor_for_option #content4').removeClass('is-invalid')
          this.content4 = CKEDITOR.instances['content4'].getData()
          this.radiok_option4()
        }else{
          $('.custom_editor_for_option #content4').attr('aria-invalid', 'true')
          $('.custom_editor_for_option #content4').addClass('is-invalid')
          this.content4 = ''
          this.keyupOption4 = false
        }
      })
      
    },
    getQuizQuestionDetailsAgain() {
      this.$store.dispatch('getQuizQueDetailssByIdFun', {
        id: this.$route.params.QueAnsId
      }).then((response) => {
        this.is_correct1 = this.$store.getters.getQuizQuesDetailsByIdDataState.data.options[0].is_correct
        this.is_correct2 = this.$store.getters.getQuizQuesDetailsByIdDataState.data.options[1].is_correct
        this.is_correct3 = this.$store.getters.getQuizQuesDetailsByIdDataState.data.options[2].is_correct
        this.is_correct4 = this.$store.getters.getQuizQuesDetailsByIdDataState.data.options[3].is_correct
      })
    },
    validateUpdateQuizBeforeSubmit(e) {
      this.$validator.validateAll().then((result) => {
        this.submitted = true;
        if (result) {
          let data = {
            quiz: this.$route.params.quizId,
            content: this.questionData.content,
            type:2,
            options: [{
              content: this.content1,
              is_correct: this.is_correct1,
              index: this.index1
            },
            {
              content: this.content2,
              is_correct: this.is_correct2,
              index: this.index2
            },
            {
              content: this.content3,
              is_correct: this.is_correct3,
              index: this.index3
            },
            {
              content: this.content4,
              is_correct: this.is_correct4,
              index: this.index4
            }]
          }
          this.$store.dispatch('updateQuizQueDetailssByIdFun', {
            data: {
              data: data,
              id: this.$route.params.QueAnsId
            }
          })
            .then((res) => {
              toast.success(res.data.msg);
               
            this.$router.push('/course/public/quizzes/' + this.pub_catID + '/question-answer/' + this.quizData.quizId + /list/)
            })
            .catch((err) => { })
          return
        }
      });
    },
    rightOptionClickFun(radioId) {
      this.submitted = true;
      if(this.radio_option == 'option1'){
        this.is_correct1 = true,
        this.optionIs_iscorrect = this.is_correct1
      }
      if(this.radio_option == 'option2'){
        this.is_correct2 = true,
        this.optionIs_iscorrect = this.is_correct2
      }
      if(this.radio_option == 'option3'){
        this.is_correct3 = true,
        this.optionIs_iscorrect = this.is_correct3
      }
      if(this.radio_option == 'option4'){
        this.is_correct4 = true,
        this.optionIs_iscorrect = this.is_correct4
      }
      let data = {
        is_correct: this.optionIs_iscorrect
      }
      this.$store.dispatch('updateQuizQueOptionByIdFun', {
        data: {
          data: data,
          id: radioId
        }
      })
        .then((res) => {
          toast.success(res.data.msg);
          this.getQuizQuestionDetailsAgain()
        })
        .catch((err) => { })
      return
    },
    radiok_option1() {
      this.keyupOption1 = true
    },
    radiok_option2() {
      this.keyupOption2 = true
    },
    radiok_option3() {
      this.keyupOption3 = true
    },
    radiok_option4() {
      this.keyupOption4 = true
    },
    validateUpdateOption1BeforeSubmit(Optionid) {
      this.$validator.validateAll().then((result) => {
        this.submitted = true;
        if (result) {
          if (this.keyupOption1 == true) {
            this.optionContent = this.content1
            this.optionIs_iscorrect = this.is_correct1
          }
          let data = {
            content: this.optionContent,
            is_correct: this.optionIs_iscorrect
          }
          this.$store.dispatch('updateQuizQueOptionByIdFun', {
            data: {
              data: data,
              id: Optionid
            }
          })
            .then((res) => {
              toast.success(res.data.msg);
            // this.$router.push('/course/public/quizzes/' + this.pub_catID + '/question-answer/' + this.quizData.quizId + /list/)
            })
            .catch((err) => { })
          return
        }
      });
    },
    validateUpdateOption2BeforeSubmit(Optionid) {
      this.$validator.validateAll().then((result) => {
        this.submitted = true;
        if (result) {
          if (this.keyupOption2 == true) {
            this.optionContent = this.content2
            this.optionIs_iscorrect = this.is_correct2
          }
          let data = {
            content: this.optionContent,
            is_correct: this.optionIs_iscorrect
          }
          this.$store.dispatch('updateQuizQueOptionByIdFun', {
            data: {
              data: data,
              id: Optionid
            }
          })
            .then((res) => {
              toast.success(res.data.msg);
              
            // this.$router.push('/course/public/quizzes/' + this.pub_catID + '/question-answer/' + this.quizData.quizId + /list/)
            })
            .catch((err) => { })
          return
        }
      });
    },
    validateUpdateOption3BeforeSubmit(Optionid) {
      this.$validator.validateAll().then((result) => {
        this.submitted = true;
        if (result) {
          if (this.keyupOption3 == true) {
            this.optionContent = this.content3
            this.optionIs_iscorrect = this.is_correct3
          }
          let data = {
            content: this.optionContent,
            is_correct: this.optionIs_iscorrect
          }
          this.$store.dispatch('updateQuizQueOptionByIdFun', {
            data: {
              data: data,
              id: Optionid
            }
          })
            .then((res) => {
              toast.success(res.data.msg);
               
            // this.$router.push('/course/public/quizzes/' + this.pub_catID + '/question-answer/' + this.quizData.quizId + /list/)
            })
            .catch((err) => { })
          return
        }
      });
    },
    validateUpdateOption4BeforeSubmit(Optionid) {
      this.$validator.validateAll().then((result) => {
        this.submitted = true;
        if (result) {
          if (this.keyupOption4 == true) {
            this.optionContent = this.content4
            this.optionIs_iscorrect = this.is_correct4
          }
          let data = {
            content: this.optionContent,
            is_correct: this.optionIs_iscorrect
          }
          this.$store.dispatch('updateQuizQueOptionByIdFun', {
            data: {
              data: data,
              id: Optionid
            }
          })
            .then((res) => {
              toast.success(res.data.msg);
              
            // this.$router.push('/course/public/quizzes/' + this.pub_catID + '/question-answer/' + this.quizData.quizId + /list/)
            })
            .catch((err) => { })
          return
        }
      });
    }
  },
  beforeMount() {
  },
  watch: {
    getQuizQuesdetails() {
      return this.$store.getters.getQuizDetailsByIdDataState
    }
  },
}